import layoutActionTypes from "constants/layout";
import { DARK, LIGHT, ThemeModel } from "constants/theme";
import { handleActions } from "redux-actions";

const { TOGGLE_FULLSCREEN, TOGGLE_THEME, TOGGLE_SIDEBAR, PUT_DATA, CLEAR_DATA } = layoutActionTypes;
const themeValue = localStorage.getItem("theme");

const initialState = {
    fullscreen: false,
    sidebarOpened: false,
    theme: ([null, undefined, "null"].includes(themeValue) ? LIGHT : themeValue) as ThemeModel,
    data: {},
};

type State = {
    fullscreen: boolean;
    sidebarOpened: boolean;
    theme: ThemeModel;
    data: {};
};

type PutDataPayload = { data: {} };
type ToggleSidebarPayload = boolean;

type CombinedPayload = PutDataPayload | ToggleSidebarPayload;

export default handleActions<State, CombinedPayload>(
    {
        [TOGGLE_FULLSCREEN]: (state) => ({
            ...state,
            fullscreen: !state.fullscreen,
        }),
        [TOGGLE_THEME]: (state) => ({
            ...state,
            theme: state.theme === DARK ? LIGHT : DARK,
        }),
        [TOGGLE_SIDEBAR]: (state, { payload }) => ({
            ...state,
            sidebarOpened: !!payload,
        }),
        [PUT_DATA]: (state, { payload }) => ({
            ...state,
            data: payload,
        }),
        [CLEAR_DATA]: (state) => ({
            ...state,
            data: {},
        }),
    },
    initialState,
);
